import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

const featuresSchema = t.object({
  toggleItem: t.boolean,
});

export type Features = t.SchemaType<typeof featuresSchema>;

const features = defineMessage({
  type: 'navigation-features' as const,
  payloadSchema: t.object({ features: featuresSchema }),
});

const getFeatures = defineMessage({
  type: 'get-navigation-features' as const,
  payloadSchema: t.object({ source: t.string }),
  reply: features,
});

export const featuresApi = {
  getFeatures,
  features,
} as const;
